/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl } from "@mui/material";
import Slider from "@mui/material/Slider";
import { getIn } from "formik";
import { ErrorMessage, ContexualHelp } from "../../Notifications";
import { areEqualFieldProps } from "../utils";
import { mapSliderValues } from "./utils/mapSliderValues";

import { SliderContainer, StyledSlider, Label, InfoTitle } from "./styled";

const SliderBase = ({
  field,
  infoTitle,
  options,
  label,
  form: { errors, touched, setFieldValue },
  contextualHelpText,
  contextualHelpProps = {},
  min,
  max,
  minLabel,
  maxLabel,
  onChange = value => setFieldValue(field.name, value),
  labelPosition = "top",
  ...rest
}) => {
  const errorMessage = getIn(errors, field.name);
  const isError = errorMessage && getIn(touched, field.name);
  const [sliderOptions, setSliderOptions] = useState({
    values: options,
    minValue: 0,
    maxValue: 0,
    value: null
  });

  useEffect(() => {
    const newOptions = mapSliderValues(options, min, max, field.value);
    setSliderOptions(newOptions);
  }, [options, field.value]);

  const handleChange = (event, value) => {
    const { values } = sliderOptions;
    const selectedValueObj = values.find(option => option.value === value);

    onChange(values[0].displayText !== undefined ? selectedValueObj.actualValue : value);
  };

  const { values, minValue, maxValue, value } = sliderOptions;

  return (
    <ContexualHelp title={contextualHelpText} {...contextualHelpProps}>
      <FormControl className="formControl">
        <SliderContainer>
          {label && <Label>{label}</Label>}
          <StyledSlider length={values.length} labelPosition={labelPosition}>
            <Slider
              min={minValue}
              max={maxValue}
              marks={values}
              {...field}
              {...rest}
              onChange={handleChange}
              value={value || null}
            />
          </StyledSlider>
          {infoTitle && <InfoTitle>{infoTitle}</InfoTitle>}
        </SliderContainer>
        {isError && <ErrorMessage error={errorMessage} />}
      </FormControl>
    </ContexualHelp>
  );
};

SliderBase.propTypes = {
  field: PropTypes.object.isRequired,
  infoTitle: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldValue: PropTypes.func
  }).isRequired,
  contextualHelpText: PropTypes.string,
  contextualHelpProps: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  onChange: PropTypes.func,
  labelPosition: PropTypes.oneOf(["top", "bottom"])
};

export const CustomSlider = memo(SliderBase, areEqualFieldProps);
